
let inject = [
    'BlogService',
    '$timeout',
];

class RelatedPostsController {
    constructor(BlogService,$timeout) {
        this.$timeout=$timeout;
        this.BlogService = BlogService;
    }

    $onInit() {
        //console.log("aqui viene");
        this.getRelatedPosts();
    }

    getRelatedPosts() {
        var slugs=[];
        angular.forEach(this.categories,function(key,value){
          slugs.push(key.slug);
        });
        slugs=slugs.join();

        this.BlogService.getRelatedPosts({category:slugs}).then(response => {
            this.relatedPosts = response.posts;

            //console.log(this.relatedPosts);
            this.initRelatedPostsCarousel();
            this.loadingRelatedPosts = false;
        }).catch(error => {

        });
    }



    initRelatedPostsCarousel() {
        this.$timeout(function () {
            let purchasedItems = $('.related-items-slider.owl-carousel');
            purchasedItems.owlCarousel({
                items: 1,
                slideSpeed: 400,
                autoPlay: 8000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
            }).data('navigationBtns', ['#des-items-slider-prev', '#des-items-slider-next']);
            purchasedItems.each(function () {
                let $this = $(this),
                    owlCarousel = $this.data('owlCarousel'),
                    owlBtns = $this.data('navigationBtns'),
                    prevBtn, nextBtn;

                if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
                    return;
                }

                for (let key in owlBtns) {
                    if (owlBtns[key].indexOf('next') === -1) {
                        prevBtn = $(owlBtns[key]);
                    } else {
                        nextBtn = $(owlBtns[key]);
                    }
                }

                prevBtn.on('click touchstart', function (e) {
                    owlCarousel.prev();
                    e.preventDefault();
                });

                nextBtn.on('click touchstart', function (e) {
                    owlCarousel.next();
                    e.preventDefault();
                });
            });

            $('.add-tooltip').tooltip();
        }, 1000);
    }

}

RelatedPostsController.$inject = inject;

export default RelatedPostsController;




// WEBPACK FOOTER //
// ./www/components/blog/related-posts/related-posts.controller.js